import { useLanguage } from '../../shell/language-context';

// Play/pause + one dot per card under a marquee rail (design ofDots / htDots). A dot
// stops the marquee and centres its card; play resumes the loop.
export function MarqueeControls({
  count,
  selected,
  onSelect,
  onToggle,
  playLabel,
  dotLabel,
  className,
}: {
  count: number;
  selected: number | null;
  onSelect: (i: number) => void;
  onToggle: () => void;
  playLabel: string;
  dotLabel: (i: number) => string;
  className?: string;
}) {
  const { t } = useLanguage();
  const paused = selected !== null;
  return (
    <div className={className ? `hm-mq ${className}` : 'hm-mq'}>
      <button
        type="button"
        className="hm-mq__play"
        aria-label={playLabel}
        title={playLabel}
        aria-pressed={!paused}
        onClick={onToggle}
      >
        {paused ? (
          <span className="hm-mq__tri" aria-hidden="true" />
        ) : (
          <span className="hm-mq__bars" aria-hidden="true">
            <span />
            <span />
          </span>
        )}
        <span className="visually-hidden">{paused ? t('dc50.mq.paused') : t('dc50.mq.playing')}</span>
      </button>
      {Array.from({ length: count }, (_, i) => (
        <button
          key={i}
          type="button"
          className={selected === i ? 'hm-mq__dot is-on' : 'hm-mq__dot'}
          aria-label={dotLabel(i)}
          aria-current={selected === i ? 'true' : undefined}
          onClick={() => onSelect(i)}
        />
      ))}
    </div>
  );
}

// Translate that centres card `i` in a rail `railWidth` wide, never past the start
// (design `ofDotPx`).
export function centreOffset(i: number, railWidth: number, cardWidth: number, gap = 16): number {
  return Math.min(0, railWidth / 2 - (i * (cardWidth + gap) + cardWidth / 2));
}
